module.exports = require("dom-helpers/activeElement");


//////////////////
// WEBPACK FOOTER
// external "dom-helpers/activeElement"
// module id = 17
// module chunks = 0